import React, { useState } from 'react';
import { Button, TextButton, Text } from '@amzn/storm-ui';
import { useFormContext } from 'react-hook-form';
import useIntl from '@i18n/useIntl';
import * as formConstants from '@components/form/constants';
import ConfirmationModal from '@components/modals/ConfirmationModal';
import { toggleAccountNameEditMode } from 'src/shared/state/account-settings-slice';
import useSubmit from 'src/pages/accountSettings/hooks/useSubmit';
import {
  ACCOUNT_SETTINGS_CONFIRM_MODAL_ID,
  CONFIRMATION_MODAL_CANCEL_BUTTON_TRANSLATION_KEY,
  CONFIRMATION_MODAL_CONFIRM_BUTTON_TRANSLATION_KEY,
  CONFIRMATION_MODAL_HEADER_TRANSLATION_KEY,
  CONFIRMATION_MODAL_MESSAGE_TRANSLATION_KEY,
} from 'src/pages/accountSettings/constants';
import { ActionsButtonsWrapper } from '@components/form/style';
import {
  AccountSettingsControllersWrapper,
  AccountSettingsForm,
} from 'src/pages/accountSettings/style';
import AccountNameController from '@features/account-settings/components/AccountNameController';
import { ACCOUNT_DISPLAY_NAME_FIELD_EDIT_LABEL } from '@features/account-settings/constants';

const AccountNameForm = () => {
  const { intl } = useIntl();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const { handleSubmit } = useFormContext();
  const { isLoading, onSubmit, onReset } = useSubmit(toggleAccountNameEditMode);

  const cancelChangesHandler = () => {
    setIsModalOpen(false);
    onReset();
  };

  return (
    <AccountSettingsForm onSubmit={handleSubmit(onSubmit)}>
      <AccountSettingsControllersWrapper>
        <AccountNameController
          labelKey={ACCOUNT_DISPLAY_NAME_FIELD_EDIT_LABEL}
        />
      </AccountSettingsControllersWrapper>
      <ActionsButtonsWrapper>
        <Button variant="primary" type="submit" loading={isLoading}>
          {intl.getMessage(formConstants.SUBMIT_BUTTON_TRANSLATION_KEY)}
        </Button>
        <TextButton onClick={() => setIsModalOpen(true)}>
          {intl.getMessage(formConstants.CANCEL_BUTTON_TRANSLATION_KEY)}
        </TextButton>
      </ActionsButtonsWrapper>
      <ConfirmationModal
        id={ACCOUNT_SETTINGS_CONFIRM_MODAL_ID}
        header={
          <Text size={'large'}>
            {intl.getMessage(CONFIRMATION_MODAL_HEADER_TRANSLATION_KEY)}
          </Text>
        }
        isOpen={isModalOpen}
        cancelButtonText={intl.getMessage(
          CONFIRMATION_MODAL_CANCEL_BUTTON_TRANSLATION_KEY,
        )}
        confirmButtonText={intl.getMessage(
          CONFIRMATION_MODAL_CONFIRM_BUTTON_TRANSLATION_KEY,
        )}
        onConfirm={cancelChangesHandler}
        onCancel={() => setIsModalOpen(false)}
      >
        <Text size={'base'}>
          {intl.getMessage(CONFIRMATION_MODAL_MESSAGE_TRANSLATION_KEY)}
        </Text>
      </ConfirmationModal>
    </AccountSettingsForm>
  );
};

export default AccountNameForm;
